export default {
  download: "download",
  OurCases: "Our Cases",
  QualificationsandHonors: "Qualifications and Honors",
  Currentlocation: "Current location",
  NewsandInformation: "News and Information",
  source: "source",
  Releasetime: "Release time",
  Clickcount: "Click count",
  Back: "Back",
  ProfessionalManufacturing: "Professional Manufacturing",
  ProductCenter: "Product Center",
  ProductOverview: "Product Overview",
  RelatedProducts: "Related Products",
  Submissionsuccessful: "Submission successful",
  rules: {
    submit: "submit",
    nameRequired: "Please enter your name",
    emailRequired: "Please enter your email address",
    phoneRequired: "Please enter phone number",
    addressRequired: "Please enter the region",
  },
  navs: {
    home: "Home",
    product: "Product",
    ts: "Production R&D",
    news: "News",
    AboutUs: "About Us",
    ContactUs: "Contact Us",
    Technology: "Technology",
    Services: "R&D",
    case: "Produce",
  },
  home: {
    Seemore: "See more",
    Viewdetails: "View details",
  },
};
